<template>
  <v-row justify="center">
    <v-dialog
      origin="top center"
      v-model="dialogStatus"
      persistent
      content-class="warranty-dialog"
      :max-width="dialogWidth"
    >
      <v-card>
        <v-card-title
          class="headline dialog-custom-header white-background custom-border-bottom custom-header-blue-text"
        >
          Visit Listing
        </v-card-title>
        <v-card-text class="p-8 font-size-16">
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll"
            style="max-height: 100vh; position: relative"
          >
            <v-row>
              <v-col md="12" style="margin-top: -20px !important">
                <v-simple-table class="inner-simple-table" fixed-header>
                  <template v-slot:default>
                    <thead
                      style="
                        background-color: rgb(243, 246, 249);
                        color: rgb(36, 50, 109);
                      "
                    >
                      <tr class="custom-border-bottom">
                        <td class="font-size-16 font-weight-700 pt-2">
                          Visit #
                        </td>
                        <td
                          class="font-size-16 font-weight-700 pt-2"
                          width="40%"
                        >
                          Visit Title
                        </td>
                        <td class="font-size-16 font-weight-700 pt-2">
                          Started At
                        </td>
                        <td class="font-size-16 font-weight-700 pt-2">
                          Finished At
                        </td>
                        <td class="font-size-16 font-weight-700 pt-2">
                          Status
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="visitArr?.length > 0">
                        <tr
                          v-for="(data, index) in visitArr"
                          :key="index"
                          :class="{ 'orange_lighten-5': index % 2 == 0 }"
                        >
                          <td class="py-2 font-weight-500">
                            <v-chip
                              class="mr-2 font-weight-600"
                              color="chip-custom-blue"
                              label
                              small
                              outlined
                              @click="pushToVisit(data?.visit_id)"
                            >
                              {{ data?.barcode }}
                            </v-chip>
                          </td>
                          <td
                            class="py-2 font-weight-500"
                            width="40%"
                            v-if="data?.visit_title"
                          >
                            {{ data.visit_title }}
                          </td>

                          <td class="py-2">
                            <span
                              class="font-weight-500"
                              v-if="data?.started_at"
                            >
                              {{ formatDate(data.started_at) }}
                              {{ formatDateTimeStart(data.started_at) }}
                            </span>
                          </td>
                          <td class="py-2">
                            <span
                              class="font-weight-500"
                              v-if="data?.finished_at"
                            >
                              {{ formatDate(data.finished_at) }}
                              {{ formatDateTimeStart(data.finished_at) }}
                            </span>
                          </td>
                          <td class="py-2">
                            <v-chip
                             v-if="data.visit_status > 0"
                              class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                              :color="getStatusColor(data.visit_status)"
                              label
                              small
                              :text-color="
                                data.visit_status == 2 ? 'black' : 'white'
                              "
                            >
                              {{ data.visit_status_text }}
                            </v-chip>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td :colspan="6">
                            <p
                              class="m-0 row-not-found text-center font-weight-500 font-size-16"
                            >
                              Sorry! No visits(s) Found.
                            </p>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </perfect-scrollbar>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="warrant-manage-action">
            <v-btn
              depressed
              :disabled="visitLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="$emit('close:dialog')"
              >Close
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style scoped>
.v-dialog__content {
  align-items: start;
}
.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: 18px;
  padding: 0;
}
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: 100%;
}
</style>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  name: "create-or-update-warranty",
  mixins: [CommonMixin],
  props: {
    dialogStatus: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  watch: {
    dialogStatus: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.openVisit(this.parentId);
        }
      },
    },
  },
  data() {
    return {
      formValid: true,

      visitLoading: false,
      visitArr: [],
    };
  },
  methods: {
    pushToVisit(id) {
      const route = this.$router.resolve({
        name: "admin.visit.detail",
        params: { id },
      });
      window.open(route.href, "_blank");
    },

    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    openVisit(id) {
      const _this = this;

      /* let schedule = new Object(); */

      /* if (this.scheduleType == "one-off") {
        schedule = this.oneOffSchedule;
      }

      if (this.scheduleType == "recurring") {
        schedule = this.recurringSchedule;
      } */

      /* const startDate = schedule.start_date;
      const startTime = schedule.start_time;
      const endDate = schedule.end_date;
      const endTime = schedule.end_time;

      
      const startTime24 = moment(startTime, ["h:mm A"]).format("HH:mm");
      const endTime24 = moment(endTime, ["h:mm A"]).format("HH:mm"); */

      _this.visitLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: "assigned/tools",
          data: {
            tool: id,
            /*  start_date: moment(startDate).format("YYYY-MM-DD"),
            start_time: startTime24,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            end_time: endTime24, */
          },
        })
        .then(({ data }) => {
          _this.visitArr = data.rows;
          /* console.log(this.visitArr, "data"); */
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.visitLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["recurringSchedule", "oneOffSchedule", "scheduleType"]),
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
  /* mounted(){
      this.selectedAll = true;
    } */
};
</script>
